// Prevent Edge bfcache accumulation — forces clean load on back/forward navigation
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    window.location.reload();
  }
});

//homepage shopy by bestsellers
document.addEventListener('DOMContentLoaded', function() {
  // Select all the category links
  const categoryLinks = document.querySelectorAll('.shop_by_item .shop_by_title');
  
  // Loop through each link and update the href
  categoryLinks.forEach(link => {
    const currentHref = link.getAttribute('href');

    if (currentHref.indexOf('?') === -1) {
      link.setAttribute('href', currentHref + '?sort_by=best-selling');
    }

  });
});


document.addEventListener('DOMContentLoaded', function() {
  const desc = document.querySelector('.product-description');
  if (desc) desc.style.textTransform = 'none';
});



// Wrap everything in a function to avoid polluting the global scope
(function() {
  console.log("1928.com Enhancement Script Loaded!");

  // --- SMOOTH SCROLL-IN ANIMATIONS ---

  // Select all the elements we want to animate.
  // We're targeting section titles, collection lists, product grids, etc.
  const elementsToAnimate = document.querySelectorAll(
    '.section-header, .collection-list, .product-list, .image-with-text, .multicolumn, .footer__block'
  );

  // Give each of these elements our "before" state class
  elementsToAnimate.forEach(el => {
    el.classList.add('fade-in-element');
  });

  // Set up the Intersection Observer
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      // If the element is in the viewport
      if (entry.isIntersecting) {
        // Add the 'is-visible' class to trigger the animation
        entry.target.classList.add('is-visible');
        // We only want the animation to happen once, so unobserve the element
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1 // Trigger when 10% of the element is visible
  });

  // Start observing all the targeted elements
  elementsToAnimate.forEach(element => {
    observer.observe(element);
  });

  // --- BONUS: SLIGHT PARALLAX ON HERO BANNER ---
  // This adds a subtle depth effect to the main banner as you scroll

  const heroBanner = document.querySelector('.slideshow__media');
  if (heroBanner) {
    window.addEventListener('scroll', () => {
      const scrollPosition = window.pageYOffset;
      // Move the background image slightly slower than the scroll speed
      heroBanner.style.transform = `translateY(${scrollPosition * 0.2}px)`;
    });
  }

})();

// Keep sticky nav cart count in sync with main header cart badge
(function() {
  function updateStickyBadge(count) {
    var el = document.querySelector('.sticky-nav-cart__count');
    if (!el) return;
    if (count > 0) {
      el.textContent = count;
      el.style.display = '';
    } else {
      el.textContent = '';
      el.style.display = 'none';
    }
  }

  function fetchCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateStickyBadge(cart.item_count); })
      .catch(function() {});
  }

  // 1. Intercept XMLHttpRequest (what Symmetry/jQuery uses)
  var origXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    if (typeof url === 'string' && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1 || url.indexOf('/cart/clear') !== -1)) {
      this.addEventListener('load', function() {
        setTimeout(fetchCartCount, 400);
      });
    }
    return origXHROpen.apply(this, arguments);
  };

  // 2. Intercept fetch (in case any app uses it)
  var origFetch = window.fetch;
  window.fetch = function(input) {
    var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');
    var result = origFetch.apply(this, arguments);
    if (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1 || url.indexOf('/cart/clear') !== -1) {
      result.then(function() { setTimeout(fetchCartCount, 400); }).catch(function() {});
    }
    return result;
  };

  // 3. Listen for Shopify/theme custom events
  document.addEventListener('cart:updated', fetchCartCount);
  document.addEventListener('ajaxProduct:added', fetchCartCount);
  document.addEventListener('cart:build', fetchCartCount);

  // 4. Initial sync on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchCartCount);
  } else {
    fetchCartCount();
  }
})();
